import React, { useState, useEffect, useContext, useMemo, useCallback, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";

import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import qrcode from "qrcode";
import { encode } from "base64-arraybuffer";
import {
  obtenerUbicacionArticulo,
  mensajeUbicacionArticulo,
  alternativasMismoArticulo,
} from "../../../../utils/ubicacionArticulo";

function VentasTiendasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_VENTAS_TIENDAS = import.meta.env.VITE_URL_VENTAS_TIENDAS;
  const URL_ARTICULOS_VENTAS_TIENDAS = import.meta.env
    .VITE_URL_ARTICULOS_VENTAS_TIENDAS;
  const URL_ABONOS_TIENDAS = import.meta.env.VITE_URL_ABONOS_TIENDAS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_SEND_MAIL = import.meta.env.VITE_URL_SEND_MAIL;
  const URL_PAQUETERIAS = import.meta.env.VITE_URL_PAQUETERIAS;
  const URL_GRUPOS = import.meta.env.VITE_URL_GRUPOS;
  const URL_DEPARTAMENTOS_CLIENTES = import.meta.env
    .VITE_URL_DEPARTAMENTOS_CLIENTES;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
  const URL_ARTICULOS_PROPORCION = import.meta.env
    .VITE_URL_ARTICULOS_PROPORCION;
  const CLIENTES_DIVERSOS = import.meta.env.VITE_CLIENTE_DIVERSOS;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  let hora = moment(date).format("HH:mm:ss");

  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedColaboradorName, setSelectedColaboradorName] = useState("");
  const [value, setValue] = useState(null);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [expandedTables, setExpandedTables] = useState({});

  const [paqueterias, setPaqueterias] = useState([]);
  const [idPaqueteria, setIdPaqueteria] = useState("647e2090513ca00014b4edbc");
  const [inventarios, setInventarios] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedAreaName, setSelectedAreaName] = useState("");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  // Distingue "no hay existencia en esta tienda" de "no pude consultar el
  // inventario": antes los dos casos daban el mismo mensaje.
  const [inventariosError, setInventariosError] = useState(false);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const [fecha, setFecha] = useState(hoy);
  const [condPago, setCondPago] = useState("Contado");
  const [observaciones, setObservaciones] = useState("NA");
  const [urlPhoto, setUrlPhoto] = useState("");
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);
  const [alertasCliente, setAlertasCliente] = useState("No");
  const [listaPrecios, setListaPrecios] = useState(1);

  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transfer, setTransfer] = useState(0);
  const [fechaTransfer, setFechaTransfer] = useState("NA");
  const [destino, setDestino] = useState("NA");
  const [terminal, setTerminal] = useState("NA");
  const [fiscal, setFiscal] = useState("No");
  const [saldo, setSaldo] = useState(0);

  const [inputFields, setInputFields] = useState([]);

  const [manualInput, setManualInput] = useState({
    articulosNombre: "",
    articulos: "",
    idColor: "",
    idTalla: "",
    tallaNombre: "",
    cantInv: 0,
    cantidad: 0,
    colores: [],
    tallas: [],
    total: 0,
    idProporcion: "",
  });

  // Ref para el debounce de la pistola (scanner)
  // Ref para el input del scanner (uncontrolled para evitar race conditions con la pistola)
  const scannerInputRef = useRef(null);

  const [inputArticulos, setInputArticulos] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cajas: 0,
      precio: 0,
      articulosNombre: "",
      colores: [],
      tallas: [],
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  const [mailAutEnviado, setMailAutEnviado] = useState(false);
  const [randomCambiaPrecio, setRandomCambiaPrecio] = useState(
    (Math.random() + 1).toString(36).substring(2)
  );

  // Crear Clientes
  const [vistaCliente, setVistaCliente] = useState(false);
  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("NA");
  const [RFC, setRFC] = useState("NA");
  const [calle, setCalle] = useState("NA");
  const [numero_ext, setNumeroExt] = useState("NA");
  const [numero_int, setNumeroInt] = useState("NA");
  const [delegacion, setDelegacion] = useState("NA");
  const [estado, setEstado] = useState("NA");
  const [pais, setPais] = useState("Mexico");
  const [cp, setCP] = useState(0);
  const [colonia, setColonia] = useState("NA");
  const [ciudad, setCiudad] = useState("NA");
  const [plazo, setPlazo] = useState(0);
  const [regFiscal, setRegFiscal] = useState("0");
  const [usoCFDI, setUsoCFDI] = useState("G01");
  const [formaPagoSAT, setFormaPagoSAT] = useState("01");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("NA");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("PUE");
  const [telefono, setTelefono] = useState("1");
  const [email, setEmail] = useState("a@a.a");
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");
  const [selectedPaqueteria, setSelectedPaqueteria] = useState(
    "647e2090513ca00014b4edbc"
  );
  const [selectedAreaCliente, setSelectedAreaCliente] = useState("");
  const [selectedVendedorInput, setSelectedVendedorInput] = useState("");
  const [selectedVendedor, setSelectedVendedor] = useState("");
  const [observacionesCliente, setObservacionesCliente] = useState("NA");
  const [forma_pago, setFormaPago] = useState("Contado");
  const [descuentoCliente, setDescuentoCliente] = useState(0);

  const [areaUserName, setAreaUserName] = useState("");

  // Memoized function to update totals - defined early to avoid reference errors
  const ActualizaTotales = useCallback(() => {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  }, [inputFields, selectedImpuesto, comisionTDC, comisionFlete, efectivo, tdc, transfer]);

  // Prevent Enter from submitting the form
  const preventEnterSubmit = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  // Fetch areas only once on mount
  useEffect(() => {
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [URL_AREAS]);

  // Fetch clients and inventory when user.areas changes
  useEffect(() => {
    if (!user?.areas) return;

    setAreaUserName(user.areaName);
    setSelectedArea(user.areas);
    setSelectedAreaCliente(user.areas);

    axios
      .get(`${URL_CLIENTES}Activos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_INVENTARIOS}VentaTienda/${user.areas}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allInventarios = res.data;
        setInventarios(allInventarios);
        setInventariosError(false);
        if (res.data?.[0]?.area) {
          setSelectedAreaName(res.data[0].area);
        }
        let unicos = allInventarios.filter(
          (value, index, self) =>
            index ===
            self.findIndex(
              (t) => t.idArticulo === value.idArticulo && t.cantidad > 0
            )
        );

        setArticulosUnicos(unicos);
      })
      .catch((err) => {
        console.log(err);
        setInventariosError(true);
      });
  }, [user?.areas, URL_CLIENTES, URL_INVENTARIOS]);

  useEffect(() => {
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_PAQUETERIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPaqueterias = res.data;
        setPaqueterias(allPaqueterias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allGrupos = res.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    ActualizaTotales();
  }, [ActualizaTotales]);

  // Cliente predeterminado de la venta: el que tenga asignado el usuario en su
  // ficha. Si no tiene, se usa el de la variable de entorno, como antes.
  //
  // Se identifica al usuario por su sesion, no por su correo: asi, cuando se da
  // de alta una tienda nueva basta asignarle su cliente y funciona sola, sin
  // tocar codigo.
  //
  // Es solo el valor INICIAL: el usuario puede cambiarlo si vende a otro cliente.
  const clienteDelUsuario = Array.isArray(user?.clientes)
    ? typeof user.clientes[0] === "object"
      ? user.clientes[0]?._id
      : user.clientes[0]
    : null;
  const idClientePredeterminado = clienteDelUsuario || CLIENTES_DIVERSOS;

  useEffect(() => {
    if (clientes.length === 0 || !idClientePredeterminado) return;

    const selectedCliente = clientes.find(
      (cliente) => cliente._id === idClientePredeterminado
    );

    // Validate selectedCliente and its nested properties safely
    if (!selectedCliente) return;

    const vendedor = selectedCliente.vendedor?.[0];
    if (!vendedor?._id) return;

    setValue({
      ...selectedCliente,
      junta: `${selectedCliente.nombre_comercial || ""} ${selectedCliente.codigo || ""}`,
      firstLetter: selectedCliente.nombre_comercial?.[0]?.toUpperCase() || "#",
    });
    setAlertasCliente(selectedCliente.alertas || "No");
    setSelectedColaborador(vendedor._id);
    setSelectedVendedorInput([
      vendedor._id,
      `${vendedor.nombre || ""} ${vendedor.apellido || ""}`,
    ]);
    setSelectedColaboradorName(
      `${vendedor.nombre || ""} ${vendedor.apellido || ""}`
    );
    setListaPrecios(selectedCliente.listaPrecios || 1);
  }, [clientes, idClientePredeterminado]);

  const handleManualArticuloChange = (selectedArticulo) => {
    // Filter inventory for the selected article
    let inventario = inventarios.filter(
      (inv) => String(inv.idArticulo) === String(selectedArticulo.idArticulo)
    );

    let precioArt;
    if (listaPrecios == 1) {
      precioArt = selectedArticulo.listaPrecioPieza;
    } else if (listaPrecios == 2) {
      precioArt = selectedArticulo.listaPrecioCorrida;
    } else if (listaPrecios == 3) {
      precioArt = selectedArticulo.listaPrecioPaquete;
    } else if (listaPrecios == 4) {
      precioArt = selectedArticulo.listaPrecioCaja;
    } else if (listaPrecios == 5) {
      precioArt = selectedArticulo.listaPrecioRebajas;
    }

    // Get unique tallas from inventory
    let tallas = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.talla)) {
        acc.push(curr.talla);
      }
      return acc;
    }, []);

    // Get unique colores from inventory
    let colores = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.color)) {
        acc.push(curr.color);
      }
      return acc;
    }, []);

    // Filter selectedArticulo.colores to only include colors present in inventory
    let coloresRed = selectedArticulo.colores.filter((c) =>
      colores.includes(c.name)
    );

    // Filter selectedArticulo.tallas to only include sizes present in inventory
    let tallasRed = selectedArticulo.tallas.filter((t) =>
      tallas.includes(t.name)
    );

    if (selectedArticulo) {
      setManualInput({
        articulos: selectedArticulo.idArticulo,
        articulosNombre: selectedArticulo.nombre,

        colores: coloresRed,
        precio: precioArt,
        idProporcion: "",
        tallas: [],
        idColor: "",
        idTalla: "",
        cantidad: 0,
      });
      setUrlPhoto(selectedArticulo.urlFoto);
    }
  };
  const handleManualInputChange = (event) => {
    const { name, value } = event.target;

    setManualInput((prev) => {
      const updatedInput = {
        ...prev,
        [name]: value,
      };

      // When changing color, rebuild available tallas from inventory for this article+color
      if (name === "idColor") {
        const availableTallas = Array.from(
          new Map(
            inventarios
              .filter(
                (inv) => String(inv.idArticulo) === String(prev.articulos) && String(inv.idColor) === String(value)
              )
              .map((inv) => [inv.idTalla, { _id: inv.idTalla, name: inv.talla }])
          ).values()
        );
        updatedInput.tallas = availableTallas;
        updatedInput.idTalla = "";
        updatedInput.tallaNombre = "";
      }

      // If changing talla, update tallaNombre
      if (name === "idTalla") {
        const selectedTalla = (updatedInput.tallas || prev.tallas || []).find((t) => String(t._id) === String(value));
        updatedInput.tallaNombre = selectedTalla ? selectedTalla.name : "";
      }

      // Calculate total whenever cantidad changes
      if (name === "cantidad") {
        const selectedColor = manualInput.colores.find(
          (c) => String(c._id) === String(manualInput.idColor)
        );
        const selectedTalla = manualInput.tallas.find(
          (t) => String(t._id) === String(manualInput.idTalla)
        );
        updatedInput.cantidad = parseFloat(value);
        const inventario = inventarios.find(
          (inv) =>
            String(inv.idArticulo) === String(manualInput.articulos) &&
            inv.color === selectedColor?.name &&
            inv.talla === selectedTalla?.name
        );
        // Set when found; use backend-provided field name
        updatedInput.idProporcion = inventario?.idArticuloProporcion || "";

        if (inventario && updatedInput.cantidad > inventario.cantidad) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `La cantidad excede tu inventario de ${inventario.cantidad}`,
            showConfirmButton: false,
          });
        }
      }

      return updatedInput;
    });
  };

  const handleManualAdd = async () => {
    if (
      !manualInput.articulosNombre ||
      !manualInput.idColor ||
      !manualInput.idTalla ||
      !manualInput.cantidad
    ) {
      return;
    }

    const selectedColor = manualInput.colores.find(
      (c) => String(c._id) === String(manualInput.idColor)
    );
    const selectedTalla = manualInput.tallas.find(
      (t) => String(t._id) === String(manualInput.idTalla)
    );

    const inventario = inventarios.find(
      (inv) =>
        String(inv.idArticulo) === String(manualInput.articulos) &&
        inv.color === selectedColor.name &&
        inv.talla === selectedTalla.name
    );

    const cantidadFinal = inventario
      ? Math.min(inventario.cantidad, manualInput.cantidad)
      : manualInput.cantidad;

    if (inventario) {
      const avaible = inputFields.find(
        (i) => i.idArticuloProporcion === inventario.idArticuloProporcion
      );

      if (avaible) {
        // Create new array with updated object
        const updatedFields = inputFields.map((field) => {
          if (field.idArticuloProporcion === inventario.idArticuloProporcion) {
            return {
              ...field,
              cantidad: field.cantidad + manualInput.cantidad,
              total: (field.cantidad + manualInput.cantidad) * field.precio,
            };
          }
          return field;
        });

        setInputFields(updatedFields);
        ActualizaTotales();
        setManualInput((prev) => ({
          ...prev,
          idColor: "",
          articulos: "",
          articulosNombre: "",
          cantidad: 0,
          idTalla: "",
          tallaNombre: "",
          total: 0,
          idProporcion: "",
        }));

        return null;
      }

      const newField = {
        id: uuidv4(),
        articulos: manualInput.articulos,
        precio: manualInput.precio,
        idInv: inventario._id,
        cantInv: inventario.cantidad,
        articulosNombre: manualInput.articulosNombre,
        idArticuloProporcion: inventario.idArticuloProporcion,

        precioEsp: inventario.precioEsp,
        venta: inventario.venta,
        costoUnitario: inventario.costoUnitario,
        precioOriginal: inventario.venta,
        cantidad: cantidadFinal,
        total: cantidadFinal * manualInput.precio,

        idTalla: manualInput.idTalla,
        tallaNombre: selectedTalla ? selectedTalla.name : "",
        idColor: manualInput.idColor,
        colorNombre: selectedColor ? selectedColor.name : "",
        colores: manualInput.colores,
        tallas: manualInput.tallas,
        cajas: 0,
      };

      setInputFields((prev) => [...prev, newField]);

      // Reset only specific fields after adding
      setManualInput((prev) => ({
        ...prev,
        idColor: "",
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        idTalla: "",
        tallaNombre: "",
        total: 0,
        precio: 0,
        idProporcion: "",
      }));
    }
  };

  // Sanitizar código de barras para comparación consistente
  const sanitizeBarcode = (code) => {
    if (!code) return "";
    return code
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase()
      .trim();
  };

  // Función para manejar Enter en el scanner (pistola envía Enter al final del código)
  const handleScannerKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      const value = scannerInputRef.current?.value || "";
      if (value.trim().length >= 2) {
        procesarCodigoScanner(value.trim());
      }
      // Limpiar el input para el siguiente scan
      if (scannerInputRef.current) {
        scannerInputRef.current.value = "";
      }
    }
  };

  // Función principal para procesar el código escaneado
  /**
   * Explica por que no se puede agregar la pieza a la nota.
   *
   * La nota de tienda vende del inventario fisico de SU tienda. Si la mercancia
   * esta en bodega, el mensaje anterior ("no tiene inventario disponible") hacia
   * creer que el articulo no existia y llevaba a capturar stock de mas. Ahora se
   * consulta en que almacen esta y se dice explicitamente.
   */
  async function avisarSinExistenciaTienda({
    idArticulo,
    idColor,
    idTalla,
    articulo,
    color,
    talla,
  }) {
    if (inventariosError) {
      Swal.fire({
        icon: "error",
        title: "No se pudo consultar el inventario",
        text: "No se pudo cargar el inventario de la tienda. Reintenta o recarga la pantalla.",
      });
      return;
    }

    Swal.fire({
      title: "Consultando existencia...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const ubicacion = await obtenerUbicacionArticulo(
      URL_INVENTARIOS,
      idArticulo,
      idColor,
      idTalla
    );

    Swal.fire({
      icon: "warning",
      title: "Sin existencia en esta tienda",
      html: mensajeUbicacionArticulo({
        ubicacion,
        idAreaActual: user.areas,
        nombreAreaActual: selectedAreaName || user.areaName,
        articulo,
        color,
        talla,
        alternativas: alternativasMismoArticulo(
          inventarios,
          idArticulo,
          idColor,
          idTalla
        ),
      }),
      showConfirmButton: true,
    });
  }

  async function procesarCodigoScanner(scanValue) {
    // Validate the scan value exists
    if (!scanValue || scanValue.length < 2) {
      return;
    }

    const sanitizedValue = sanitizeBarcode(scanValue);

    // Find the article in inventory - buscar por eanProporcion, _id o idArticuloProporcion
    // Primero búsqueda exacta
    let foundArticle = inventarios.find((a) => a.eanProporcion === scanValue);

    // Si no se encuentra exacto, intentar con valor sanitizado contra EANs sanitizados
    if (!foundArticle && sanitizedValue) {
      foundArticle = inventarios.find(
        (a) => sanitizeBarcode(a.eanProporcion) === sanitizedValue
      );
    }

    // Si no se encuentra por EAN, intentar buscar por idArticuloProporcion o _id
    if (!foundArticle) {
      foundArticle = inventarios.find(
        (a) => a.idArticuloProporcion === scanValue || a._id === scanValue
      );
    }

    if (!foundArticle) {
      // Clear QR input
      setManualInput((prev) => ({
        ...prev,
        idProporcion: "",
      }));
      // Ojo: el listado de esta pantalla solo trae articulos CON existencia en la
      // tienda, asi que un codigo valido pero agotado aqui tambien cae en este
      // caso. Se aclara para no hacer creer que el articulo no existe.
      Swal.fire({
        icon: "error",
        title: "Artículo no disponible aquí",
        text: `No se encontró ese código entre los artículos con existencia en ${
          selectedAreaName || user.areaName || "esta tienda"
        }. Puede que el artículo exista pero esté agotado aquí o en otra bodega; revisa Disponible o solicita un traspaso.`,
      });
      return;
    }

    const a = foundArticle;
    const idArticulo = a.idArticulo;
    const articulosNombre = a.nombre;
    const cantInv = parseFloat(a.cantidad);
    const idInv = a._id;
    const idColor = a.idColor;
    const idTalla = a.idTalla;
    const idArticuloProporcion = a.idArticuloProporcion;

    let precio;
    if (listaPrecios == 1) {
      precio = a.listaPrecioPieza;
    } else if (listaPrecios == 2) {
      precio = a.listaPrecioCorrida;
    } else if (listaPrecios == 3) {
      precio = a.listaPrecioPaquete;
    } else if (listaPrecios == 4) {
      precio = a.listaPrecioCaja;
    } else if (listaPrecios == 5) {
      precio = a.listaPrecioRebajas;
    }

    // Check if article already exists by idArticuloProporcion
    const existing = inputFields.find(
      (i) => i.idArticuloProporcion === idArticuloProporcion
    );

    if (existing) {
      // Validate against available inventory before incrementing
      if (existing.cantidad + 1 > cantInv) {
        Swal.fire({
          icon: "error",
          title: "Inventario insuficiente",
          text: `Solo hay ${cantInv} unidades disponibles de este artículo`,
        });
        // Clear QR input
        setManualInput((prev) => ({
          ...prev,
          idProporcion: "",
        }));
        return;
      }

      // Create new array with updated object
      const updatedFields = inputFields.map((field) => {
        if (field.idArticuloProporcion === idArticuloProporcion) {
          return {
            ...field,
            cantidad: field.cantidad + 1,
            total: (field.cantidad + 1) * field.precio,
          };
        }
        return field;
      });

      setInputFields(updatedFields);
      // Clear QR input after successful operation
      setManualInput((prev) => ({
        ...prev,
        idProporcion: "",
      }));
      return;
    }

    // Validate inventory before adding new item
    if (cantInv < 1) {
      await avisarSinExistenciaTienda({
        idArticulo,
        idColor,
        idTalla,
        articulo: articulosNombre,
        color: a.color,
        talla: a.talla,
      });
      // Clear QR input
      setManualInput((prev) => ({
        ...prev,
        idProporcion: "",
      }));
      return;
    }

    const newField = {
      id: uuidv4(),
      articulos: idArticulo,
      precio: precio,
      idInv: idInv,
      cantInv: cantInv,
      articulosNombre: articulosNombre,

      precioEsp: a.precioEsp,
      venta: a.venta,
      costoUnitario: a.costoUnitario,
      precioOriginal: a.venta,
      cantidad: 1,
      total: precio,

      idTalla: idTalla,
      tallaNombre: a.talla,
      idColor: idColor,
      colorNombre: a.color,
      colores: a.colores,
      tallas: a.tallas,
      cajas: 0,
      idArticuloProporcion: idArticuloProporcion,
    };
    setUrlPhoto(a.urlFoto);

    setInputFields((prev) => [...prev, newField]);

    // Reset fields after adding
    setManualInput((prev) => ({
      ...prev,
      idColor: "",
      articulos: "",
      articulosNombre: "",
      cantidad: 0,
      idTalla: "",
      tallaNombre: "",
      total: 0,
      precio: 0,
      idProporcion: "",
    }));
  }

  const saveVenta = async (event) => {
    event.preventDefault();
    setValidaBoton(false);

    // Calculate the total paid and the balance
    const totalPaid =
      parseFloat(efectivo) + parseFloat(tdc) + parseFloat(transfer);
    const changeAmount = totalPaid - total_general;

    // Validaciones iniciales
    if (inputFields.length === 0) {
      showError("Debes agregar al menos un artículo para realizar la venta");
      setValidaBoton(true);
      return;
    }

    if (!vistaCliente && (!value || !value._id)) {
      showError("Debes seleccionar un cliente válido");
      return;
    }

    if (changeAmount > 0 && efectivo <= 0) {
      showError("No hay efectivo para dar cambio. Ajusta los montos de pago.");
      return;
    }

    if (terminal === "" && destino === "") {
      showError("Debes Capturar la Terminal o Destino");
      return;
    }

    if (condPago === "Contado" && saldo > 0) {
      showError("El Pago no coincide con el Total");
      return;
    }

    // Validación de cantidad y precios
    const cantidadIF = inputFields.length;
    const cantidadCapturada = inputFields.filter((a) => a.cantidad > 0).length;
    const preciosValidos =
      cambiarPrecio ||
      user.precio_menor ||
      inputFields.every((a) => a.precio >= a.precioOriginal - 51);

    if (cantidadCapturada !== cantidadIF) {
      showError("Existen Productos sin capturar la cantidad");
      return;
    }

    // Handle scenarios where customer overpaid and there's cash to give change
    if (changeAmount > 0) {
      // Calculate the adjusted efectivo value
      const newEfectivo = efectivo - changeAmount;

      // Show the amount of change and require confirmation before proceeding
      Swal.fire({
        icon: "warning",
        title: "El cambio a entregar al cliente es",
        text: `$${changeAmount.toFixed(2)}`,
        confirmButtonText: "Confirmar",
        showCancelButton: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Continue with the sale processing after confirmation, using newEfectivo
          try {
            toggleProgreso();

            // Use the adjusted efectivo value
            const efeGuarda = parseFloat(newEfectivo);
            const prefijo = fiscal === "Si" ? "F" : "N";
            const totalPedido = inputFields.length;

            // Si no se está creando un nuevo cliente
            if (!vistaCliente) {
              await procesarVentaExistente(efeGuarda, prefijo, totalPedido);
            }
            // Si se está creando un nuevo cliente
            else {
              if (!validarDatosCliente()) {
                showError("Por favor revisa el formulario, faltan Datos");
                return;
              }
              await procesarVentaNuevoCliente(efeGuarda, prefijo, totalPedido);
            }
          } catch (error) {
            showError("Something went wrong!", error);
            console.log(error);
          }
        }
      });
    } else {
      // No change needed, proceed directly with original calculation
      try {
        toggleProgreso();

        // Use the original efectivo + saldo calculation
        const efeGuarda = parseFloat(efectivo) + parseFloat(saldo);
        const prefijo = fiscal === "Si" ? "F" : "N";
        const totalPedido = inputFields.length;

        // Si no se está creando un nuevo cliente
        if (!vistaCliente) {
          await procesarVentaExistente(efeGuarda, prefijo, totalPedido);
        }
        // Si se está creando un nuevo cliente
        else {
          if (!validarDatosCliente()) {
            showError("Por favor revisa el formulario, faltan Datos");
            return;
          }
          await procesarVentaNuevoCliente(efeGuarda, prefijo, totalPedido);
        }
      } catch (error) {
        showError("Something went wrong!", error);
        console.log(error);
      }
    }
  };

  // Función auxiliar para mostrar errores
  const showError = (message, error = null) => {
    // Close progress modal if open
    setModalProgreso(false);

    // Extract error message from backend response if available
    let errorDetail = "";
    if (error) {
      if (error.response?.data?.error) {
        errorDetail = error.response.data.error;
      } else if (error.response?.data?.message) {
        errorDetail = error.response.data.message;
      } else if (error.message) {
        errorDetail = error.message;
      } else {
        errorDetail = String(error);
      }
    }

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: message,
      footer: errorDetail ? `Detalle: ${errorDetail}` : "",
      showConfirmButton: true,
    });
    setValidaBoton(true);
  };

  // Función para validar datos del cliente
  const validarDatosCliente = () => {
    return (
      selectedGrupo !== "" &&
      selectedDepartamento !== "" &&
      selectedPaqueteria !== "" &&
      selectedAreaCliente !== "" &&
      selectedVendedor !== ""
    );
  };

  // Función para procesar venta con cliente existente
  const procesarVentaExistente = async (efeGuarda, prefijo, totalPedido) => {
    try {
      // Preparar datos de artículos
      const articlesData = inputFields
        .filter(
          (articulo) => articulo.articulos !== "" && articulo.cantidad > 0
        )
        .map((articulo) => ({
          articulos: articulo.articulos,
          cantidad: parseFloat(articulo.cantidad),
          precio: parseFloat(articulo.precio),
          total: parseFloat(articulo.total),
          inventarios: articulo.idInv,
          costoUnitario: articulo.costoUnitario,
          colores: articulo.idColor,
          tallas: articulo.idTalla,
          articulosProporcion: articulo.idArticuloProporcion,
          colaboradores: selectedColaborador,
        }));

      // Validate all articles have valid inventory reference
      const invalidArticles = articlesData.filter((a) => !a.inventarios);
      if (invalidArticles.length > 0) {
        throw new Error(
          `${invalidArticles.length} artículo(s) sin referencia de inventario válida`
        );
      }

      // Preparar datos de pago si es al contado
      let paymentData = null;
      if (condPago === "Contado") {
        paymentData = {
          total: total_general,
          areas: user.areas,
          efectivo: efeGuarda,
          tdc,
          transfer,
          destino,
          fechaTransfer,
          terminal,
          cortesia: 0,
          codigoAgrupado,
        };
      }

      const completeVentaData = {
        fecha,
        clientes: value?._id,
        colaboradores: selectedColaborador,
        total_general: parseFloat(total_general.toFixed(2)),
        observaciones,
        total_cantidad,
        paqueterias: idPaqueteria,
        areas: user.areas,
        comisionTDC,
        comisionFlete,
        subTotal: parseFloat(subTotal.toFixed(2)),
        iva: parseFloat(iva.toFixed(2)),
        impuestos: selectedImpuesto,
        cond_pago: condPago,
        fiscal,
        saldo: parseFloat(saldo.toFixed(2)),
        cortesia: 0,
        prefijo,
        entregado: "Si",
        descuento: 0,
        areaSurtido: selectedArea,
        createClient: false,
        articles: articlesData,
        paymentData: paymentData,
      };

      const ventaResponse = await axios.post(
        `${URL_VENTAS_TIENDAS}Complete`,
        completeVentaData,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      await finalizarVenta(ventaResponse.data, prefijo, value?._id, efeGuarda);
    } catch (error) {
      throw error;
    }
  };

  // Función para procesar venta con nuevo cliente
  const procesarVentaNuevoCliente = async (efeGuarda, prefijo, totalPedido) => {
    try {
      const clienteData = {
        nombre_comercial,
        razon_social,
        RFC,
        calle,
        numero_ext,
        numero_int,
        delegacion,
        estado,
        pais,
        cp,
        colonia,
        ciudad,
        telefono,
        email,
        grupos: selectedGrupo,
        departamentosClientes: selectedDepartamento,
        vendedor: selectedVendedor,
        observaciones: observacionesCliente,
        ultimo_pago: "2000-01-01",
        forma_pago,
        areas: selectedAreaCliente,
        plazo,
        regFiscal,
        usoCFDI,
        formaPagoSAT,
        condicionesPagoSAT,
        metodoPagoSAT,
        cargosk: 0,
        abonosk: 0,
        saldok: 0,
        fiscal: "No",
        cargos: 0,
        abonos: 0,
        saldo: 0,
        descuento: descuentoCliente,
        paqueterias: selectedPaqueteria,
        alertas: "Si",
        listaPrecios: 1,
      };

      // Preparar datos de artículos
      const articlesData = inputFields
        .filter(
          (articulo) => articulo.articulos !== "" && articulo.cantidad > 0
        )
        .map((articulo) => ({
          articulos: articulo.articulos,
          cantidad: parseFloat(articulo.cantidad),
          precio: parseFloat(articulo.precio),
          total: parseFloat(articulo.total),
          inventarios: articulo.idInv,
          costoUnitario: articulo.costoUnitario,
          colores: articulo.idColor,
          tallas: articulo.idTalla,
          articulosProporcion: articulo.idArticuloProporcion,
          colaboradores: selectedVendedor,
        }));

      // Validate all articles have valid inventory reference
      const invalidArticles = articlesData.filter((a) => !a.inventarios);
      if (invalidArticles.length > 0) {
        throw new Error(
          `${invalidArticles.length} artículo(s) sin referencia de inventario válida`
        );
      }

      // Preparar datos de pago si es al contado
      let paymentData = null;
      if (condPago === "Contado") {
        paymentData = {
          total: total_general,
          areas: user.areas,
          efectivo: efeGuarda,
          tdc,
          transfer,
          destino,
          fechaTransfer,
          terminal,
          cortesia: 0,
          codigoAgrupado,
        };
      }

      const completeVentaData = {
        fecha,
        colaboradores: selectedVendedor,
        total_general: parseFloat(total_general.toFixed(2)),
        observaciones,
        total_cantidad,
        paqueterias: idPaqueteria,
        areas: user.areas,
        comisionTDC,
        comisionFlete,
        subTotal: parseFloat(subTotal.toFixed(2)),
        iva: parseFloat(iva.toFixed(2)),
        impuestos: selectedImpuesto,
        cond_pago: condPago,
        fiscal,
        saldo: parseFloat(saldo.toFixed(2)),
        cortesia: 0,
        prefijo,
        entregado: "Si",
        descuento: 0,
        areaSurtido: selectedArea,
        createClient: true,
        clientData: clienteData,
        articles: articlesData,
        paymentData: paymentData,
      };

      const ventaResponse = await axios.post(
        `${URL_VENTAS_TIENDAS}Complete`,
        completeVentaData,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // For new clients, we need to get the client ID from the response
      // The backend should return the created venta with the client ID
      await finalizarVenta(
        ventaResponse.data,
        prefijo,
        ventaResponse.data.clientes,
        efeGuarda
      );
    } catch (error) {
      throw error;
    }
  };

  // DEPRECATED: This function is no longer used since we moved to createComplete endpoint
  // const procesarPagoYArticulos = async (
  //   ventaData,
  //   efeGuarda,
  //   clienteId,
  //   prefijo,
  //   totalPedido
  // ) => {
  //   // This function has been replaced by the consolidated createComplete endpoint
  // };

  // Función para finalizar la venta
  const finalizarVenta = async (ventaData, prefijo, clienteId, efeGuarda) => {
    console.log("finalizarVenta called with:", {
      ventaData,
      prefijo,
      clienteId,
      efeGuarda,
      alertasCliente,
    });
    console.log("ventaData structure:", Object.keys(ventaData));

    // The createComplete endpoint now returns the venta document directly
    const actualVenta = ventaData;
    console.log("actualVenta:", actualVenta);
    console.log("actualVenta._id:", actualVenta._id);

    if (alertasCliente === "Si") {
      console.log("Generating PDF because alertasCliente is Si");
      console.log("actualVenta full object:", actualVenta);
      const ventaId = actualVenta._id || actualVenta.id;
      const consecutivo = actualVenta.consecutivo;
      console.log("Extracted venta ID:", ventaId, "type:", typeof ventaId);
      console.log(
        "Extracted consecutivo:",
        consecutivo,
        "type:",
        typeof consecutivo
      );

      if (!ventaId) {
        console.error("No venta ID found in response:", actualVenta);
        Swal.fire({
          icon: "warning",
          title: "PDF no generado",
          text: "No se pudo obtener el ID de la venta para generar el PDF",
        });
        return;
      }

      PDFOC(ventaId, consecutivo, prefijo, efeGuarda);
    } else {
      console.log(
        "PDF not generated because alertasCliente is:",
        alertasCliente
      );
    }

    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Venta de Tienda",
        detalle: `${clienteId} ${total_general}`,
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    setModalProgreso(false);

    // Verificar si hay pago con TDC para sugerir facturación
    if (tdc > 0) {
      Swal.fire({
        title: "¿Deseas facturar esta venta?",
        text: "Hubo pago con TDC. Debes facturar.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, facturar",
        cancelButtonText: "No por ahora",
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirige al componente de factura con el ID de la venta
          window.location.href = `/FacturasTiendasCreate/${actualVenta._id}`;
        } else {
          // Si no se confirma la facturación, mostrar mensaje de éxito y recargar
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Creado con éxito",
            text: "Por favor no refresques ni cierres la ventana",
            showConfirmButton: false,
          });

          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      });
    } else {
      // Si no hay pago con TDC, mostrar mensaje de éxito y recargar normalmente
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Creado con éxito",
        text: "Por favor no refresques ni cierres la ventana",
        showConfirmButton: false,
      });

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  };

  async function PDFOC(idPDFOC, consecutivo, prefijo, efeGuarda) {
    try {

      // Validate required parameters
      if (!idPDFOC) {
        throw new Error("ID de venta no disponible para generar PDF");
      }
      if (!consecutivo) {
        throw new Error("Número consecutivo no disponible para generar PDF");
      }

      let cambio = parseFloat(efectivo) - parseFloat(efeGuarda);

      // Format fecha to Mexican style (always today)
      const fechaMex = moment().format("DD/MM/YYYY");

      // Calculate totals from inputFields data
      let subTotalTabla = 0;
      let total_general_tabla = 0;
      let iva_tabla = 0;
      let impuesto_tabla = selectedImpuesto;

      // Calculate total pieces
      let totalPiezas = inputFields.reduce((total, item) => total + parseFloat(item.cantidad || 0), 0);

      // Process data for table - truncate long names and format properly
      const data = inputFields
        .sort((a, b) => (a.articulosNombre > b.articulosNombre ? 1 : -1))
        .map((a) => {
          // Add to subtotal calculation
          subTotalTabla += parseFloat(a.total);

          // Truncate item name if too long (max 24 chars for 8cm width)
          const itemName =
            a.articulosNombre.length > 24
              ? a.articulosNombre.substring(0, 21) + "..."
              : a.articulosNombre;

          return [
            itemName,
            a.colorNombre || "",
            a.tallaNombre || "",
            a.cantidad.toString(),
            `$${a.precio.toFixed(2)}`,
            `$${a.total.toFixed(2)}`,
          ];
        });

      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });

      // Calculate final totals
      iva_tabla = subTotalTabla * impuesto_tabla / 100;
      total_general_tabla = subTotalTabla + parseFloat(comisionTDC) + parseFloat(comisionFlete) + iva_tabla;

      // Debug logging to verify calculations
      console.log("PDF Totals Calculation:", {
        subTotalTabla,
        iva_tabla,
        comisionTDC: parseFloat(comisionTDC),
        comisionFlete: parseFloat(comisionFlete),
        total_general_tabla,
        inputFieldsCount: inputFields.length
      });

      // Calculate dynamic height based on content
      const baseHeight = 18; // Base height in cm
      const itemHeight = 0.5; // Height per item in cm
      const headerHeight = 8; // Height for header section
      const footerHeight = 12; // Height for footer, totals, payments (more for payment methods)
      const bufferHeight = 4; // Extra space at the end for cutting

      const totalHeight =
        headerHeight +
        dataPDFLimpia.length * itemHeight +
        footerHeight +
        bufferHeight;

      // Create PDF with proper thermal dimensions (8cm width) and calculated height
      const doc = new jsPDF("p", "cm", [8, totalHeight], true);

      // Generate QR code
      var base64 = await qrcode.toDataURL(idPDFOC);
      var img3 = new Image();
      img3.src = base64;

      var img2 = new Image();
      img2.src = "logoInstitucion.png";

      // HEADER SECTION with yPos tracking
      const centerX = 4; // Center of 8cm width
      const leftMargin = 0.2;
      const rightMargin = 7.8;
      let yPos = 0.3; // Start position

      // Logo
      doc.addImage(img2, "png", 6.5, yPos, 1.2, 0.8);
      yPos += 1.0; // Space after logo

      // Business information - centered with better spacing
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space after business name

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("CALLE ##, COLONIA", centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between address lines

      doc.text("CIUDAD, ESTADO CP", centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between address lines

      doc.text(`RFC:`, centerX, yPos, { align: "center" });
      yPos += 0.35; // More space after RFC

      doc.text("General de Ley de Personas Morales", centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space before separator

      // Separator line
      doc.setLineWidth(0.01);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.5; // More space after separator

      // Store information with better spacing
      doc.setFontSize(8);
      doc.text(`Tienda: ${user.areaName}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between store info lines

      doc.text(`Direccion: ${user.areaDireccion}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between store info lines

      doc.text(`Telefono: ${user.areaTelefono}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space before separator

      // Another separator
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.5; // More space after separator

      // Transaction information with better spacing
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`Fecha: ${fechaMex} ${hora}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.4; // More space after date

      doc.setFont("helvetica", "normal");
      doc.text(
        `Nota: ${prefijo}-${consecutivo} / Almacen: ${selectedAreaName}`,
        centerX,
        yPos,
        { align: "center" }
      );
      yPos += 0.5; // More space before customer info

      // Customer and seller info with better spacing
      let clienteName;
      let tel;
      let nom;

      if (!vistaCliente) {
        clienteName = value?.nombre_comercial || "Cliente";
        tel = value?.telefono || "1";
        nom = value?.nombre_comercial || "Cliente";
      } else {
        clienteName = nombre_comercial;
        tel = telefono;
        nom = nombre_comercial;
      }

      doc.text(`Cliente: ${clienteName}`, leftMargin, yPos);
      yPos += 0.35; // More space between customer and seller

      doc.text(`Vendedor: ${selectedColaboradorName}`, leftMargin, yPos);
      yPos += 0.6; // Much more space before final separator

      // Final separator before items
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.6; // Much more space before table starts

      // ITEMS TABLE with proper column widths for 8cm (6 columns)
      doc.autoTable({
        head: [["Articulo", "Color", "Talla", "Can", "Precio", "Total"]],
        body: dataPDFLimpia,
        startY: yPos, // Use yPos instead of fixed value

        // Fixed column widths that total to ~7.6cm (leaving margins) - 6 columns
        columnStyles: {
          0: {
            cellWidth: 2, // Item name (largest)
            halign: "left",
            overflow: "linebreak",
            fontSize: 7,
          },
          1: {
            cellWidth: 1, // Color
            halign: "left",
            overflow: "hidden",
            fontSize: 7,
          },
          2: {
            cellWidth: 1, // Talla
            halign: "left",
            overflow: "hidden",
            fontSize: 7,
          },
          3: {
            cellWidth: 0.8, // Cantidad
            halign: "center",
            overflow: "hidden",
            fontSize: 7,
          },
          4: {
            cellWidth: 1.3, // Precio
            halign: "right",
            overflow: "linebreak",
            fontSize: 6,
          },
          5: {
            cellWidth: 1.5, // Total
            halign: "right",
            overflow: "linebreak",
            fontSize: 6,
          },
        },

        styles: {
          fontSize: 8,
          font: "helvetica",
          cellPadding: { top: 0.2, right: 0.1, bottom: 0.2, left: 0.1 }, // More vertical padding
          lineWidth: 0.01,
          lineColor: [180, 180, 180],
          textColor: [0, 0, 0],
          overflow: "linebreak",
        },

        headStyles: {
          fontStyle: "bold",
          fontSize: 9,
          fillColor: [245, 245, 245],
          textColor: [0, 0, 0],
          halign: "center",
          cellPadding: { top: 0.25, right: 0.1, bottom: 0.25, left: 0.1 }, // More padding in header
        },

        margin: { left: leftMargin, right: leftMargin },
        tableWidth: "wrap",
        theme: "grid",
      });

      // Get the Y position after the table with much more space
      yPos = doc.lastAutoTable.finalY + 0.8; // Much more space after table

      // TOTALS SECTION
      doc.setLineWidth(0.02);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.4; // More space after line

      // Subtotal, discount, total with better spacing and simpler formatting
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);

      const totalsX = 3.8; // Move labels more to the left for better spacing

      doc.text("SubTotal:", totalsX, yPos);
      doc.text(`$${subTotalTabla.toFixed(2)}`, rightMargin - 0.1, yPos, {
        align: "right",
      });
      yPos += 0.35; // More space between lines

      // Show IVA/tax if applicable
      if (iva_tabla > 0) {
        doc.text("IVA:", totalsX, yPos);
        doc.text(`$${iva_tabla.toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      // Show commissions if applicable
      if (parseFloat(comisionTDC) > 0) {
        doc.text("Comision TDC:", totalsX, yPos);
        doc.text(`$${parseFloat(comisionTDC).toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      if (parseFloat(comisionFlete) > 0) {
        doc.text("Flete:", totalsX, yPos);
        doc.text(`$${parseFloat(comisionFlete).toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      // Separator line before total
      doc.setLineWidth(0.01);
      yPos += 0.25;

      // Total with emphasis
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);

      const totalLabelX = 3.5;
      doc.text("TOTAL:", totalLabelX, yPos);
      doc.text(`$${total_general_tabla.toFixed(2)}`, rightMargin - 0.1, yPos, {
        align: "right",
      });
      yPos += 0.4; // Space after monetary total

      // Add total pieces
      doc.text("TOTAL PIEZAS:", totalLabelX, yPos);
      doc.text(`${new Intl.NumberFormat("en-US").format(totalPiezas)}`, rightMargin - 0.1, yPos, {
        align: "right",
      });
      yPos += 0.8; // More space after pieces total

      // PAYMENT METHODS SECTION
      doc.setLineWidth(0.02);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.4;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text("FORMAS DE PAGO", centerX, yPos, { align: "center" });
      yPos += 0.5;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);

      // Only show payment methods that have values > 0 (using only variables from original code)
      if (parseFloat(efectivo) > 0) {
        doc.text(`Efectivo:`, leftMargin + 0.3, yPos);
        doc.text(
          `${parseFloat(efectivo).toFixed(2)}`,
          rightMargin - 0.1,
          yPos,
          {
            align: "right",
          }
        );
        yPos += 0.35;
      }

      if (parseFloat(tdc) > 0) {
        doc.text(`TDC:`, leftMargin + 0.3, yPos);
        doc.text(`${parseFloat(tdc).toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      if (parseFloat(transfer) > 0) {
        doc.text(`Transfer:`, leftMargin + 0.3, yPos);
        doc.text(
          `${parseFloat(transfer).toFixed(2)}`,
          rightMargin - 0.1,
          yPos,
          {
            align: "right",
          }
        );
        yPos += 0.35;
      }

      // Show change if there is any
      if (cambio > 0) {
        doc.text(`Cambio:`, leftMargin + 0.3, yPos);
        doc.text(`${cambio.toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      // If all payment methods are 0, show "Credito"
      if (
        parseFloat(efectivo) === 0 &&
        parseFloat(tdc) === 0 &&
        parseFloat(transfer) === 0
      ) {
        doc.text(`Credito`, centerX, yPos, { align: "center" });
        yPos += 0.35;
      }

      yPos += 0.5;

      // Add signature if needed
      if (condPago === "Credito") {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.text(`Firma: ________________`, leftMargin, yPos);
        yPos += 0.8;
      }

      // FOOTER with more spacing
      yPos += 0.3;
      doc.setLineWidth(0.01);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.4;

      // Store policies - centered
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.text("POLÍTICAS DE LA TIENDA", centerX, yPos, {
        align: "center",
      });
      yPos += 0.5;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);

      const policies = [
        "**** NO ES UN COMPROBANTE FISCAL ****",
        "NO SE ACEPTAN CAMBIOS NI DEVOLUCIONES",
        "NI POR DEFECTO",
        "**** GRACIAS POR SU PREFERENCIA ****",
      ];

      policies.forEach((line) => {
        doc.text(line, centerX, yPos, { align: "center" });
        yPos += 0.25;
      });

      yPos += 0.4;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("¡Gracias por su compra!", centerX, yPos, {
        align: "center",
      });
      yPos += 0.25;
      doc.text("Conserve este comprobante", centerX, yPos, {
        align: "center",
      });
      yPos += 0.4;

      // WhatsApp customer service info
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);
      doc.text("WhatsApp Atención a clientes:", centerX, yPos, {
        align: "center",
      });
      yPos += 0.25;
      doc.setFont("helvetica", "normal");
      doc.text("495 103 6208 & 495 101 1713", centerX, yPos, {
        align: "center",
      });
      yPos += 0.4;

      // QR code - properly centered
      const qrSize = 1.6;
      doc.addImage(img3, "png", centerX - qrSize / 2, yPos, qrSize, qrSize);

      // Generate and open PDF
      try {
        doc.autoPrint();
        window.open(doc.output("bloburl"), "_blank");
        console.log("PDF generated and opened successfully");

        // Show success message
        Swal.fire({
          icon: "success",
          title: "PDF Generado",
          text: "El PDF se ha generado correctamente",
          timer: 2000,
          showConfirmButton: false,
        });
      } catch (pdfError) {
        console.error("Error generating PDF:", pdfError);
        throw new Error("Error al generar el PDF: " + pdfError.message);
      }

      // WhatsApp functionality (optional, won't break PDF generation if it fails)
      try {
        var att = doc.output("arraybuffer");

        let params = new URLSearchParams({
          number: tel,
          message: `Hola ${nom}, Gracias por confiar en ${
            import.meta.env.VITE_NOMBRE_INSTITUCION
          }, estamos para servirle!
        Cualquier duda estamos a tu órdenes!
        Bendiciones que tenga buena venta!`,
          fileName: `Nota-${prefijo}${consecutivo}.pdf`,
          mimetype: "application/pdf",
        });

        // Don't await this - let it run in background
        axios
          .post(`${URL_WHATSAPP}SendPDFFront?${params.toString()}`, att, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              "Content-Type": "application/octet-stream",
            },
          })
          .then(() => {
            console.log("WhatsApp message sent successfully");
          })
          .catch((error) => {
            console.log("WhatsApp error (ignored):", error);
            // Don't show error to user for WhatsApp failures
          });
      } catch (whatsappError) {
        console.log("WhatsApp setup error (ignored):", whatsappError);
      }
    } catch (error) {
      console.error("Error in PDFOC function:", error);
      Swal.fire({
        icon: "error",
        title: "Error generando PDF",
        text: "Hubo un problema al generar el PDF",
        footer: error.message,
      });
    }
  }

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idInv: "",
        cantInv: 0,
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        precio: 0,
        precioOriginal: 0,
        total: 0,
        precioEsp: "Si",
        venta: 0,
        costoUnitario: 0,
        colores: [],
        tallas: [],
        colorNombre: "",
        tallaNombre: "",
        idColor: "",
        idTalla: "",
        cajas: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];

    // Find the field to remove by ID to get its article and color ID
    const fieldToRemove = values.find((value) => value.id === id);

    if (!fieldToRemove) return;

    // Remove all fields with the same article and color ID combination
    const filteredValues = values.filter(
      (value) =>
        !(
          String(value.articulos) === String(fieldToRemove.articulos) &&
          String(value.idColor) === String(fieldToRemove.idColor)
        )
    );

    setInputFields(filteredValues);

    let totalKG = filteredValues.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let importes = filteredValues.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        const newValue = parseFloat(event.target.value);
        const updatedItem = {
          ...i,
          [event.target.name]: newValue,
        };
        updatedItem.total = updatedItem.cantidad * updatedItem.precio;
        return updatedItem;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputCantidad = (id, event) => {
    const newValue = parseFloat(event.target.value) || 0;

    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (i.cantInv >= newValue) {
          return {
            ...i,
            cantidad: newValue,
            total: newValue * i.precio,
          };
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede tu inventario!",
            showConfirmButton: false,
          });
          return {
            ...i,
            cantidad: 0,
            total: 0,
          };
        }
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  function BuscaArticulo(id, selectedArticulo) {
    inventarios.map((a) => {
      if (a.idArticulo === selectedArticulo.idArticulo) {
        let idArticulo = a.idArticulo;
        let precio = a.venta;
        let idInv = a._id;
        let cantInv = a.cantidad;
        let articulosNombre = a.codigo;
        let precioEsp = a.precioEsp;
        let venta = a.venta;
        let costoUnitario = a.costoUnitario;
        let precioOriginal = a.venta;
        let colores = a.colores;
        let tallas = a.tallas;

        setInputArticulos({
          id: uuidv4(),
          articulos: idArticulo,
          articulosNombre: articulosNombre,
          cajas: 0,
          precio: 0,
          colores: colores,
          tallas: tallas,
        });
      }
    });
  }

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    precio,
    idInv,
    cantInv,
    articulosNombre,
    precioEsp,
    venta,
    costoUnitario,
    precioOriginal,
    colores,
    tallas
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        return {
          ...i,
          articulos: idArticulo,
          precio: precio,
          idInv: idInv,
          cantInv: cantInv,
          articulosNombre: articulosNombre,
          precioEsp: precioEsp,
          venta: venta,
          costoUnitario: costoUnitario,
          precioOriginal: precioOriginal,
          cantidad: 0,
          total: 0,
          colores: colores,
          tallas: tallas,
          colorNombre: "",
          tallaNombre: "",
          idColor: "",
          idTalla: "",
        };
      }
      return i;
    });
    setInputFields(newInputFields);
    // handleAddFields();
  };

  const options = useMemo(() => clientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial?.[0]?.toUpperCase() || "#";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  }), [clientes]);

  function calculaImpuesto(e) {
    setSelectedImpuesto(parseFloat(e));
    if (e !== 0) {
      setIva((e * subTotal) / 100);
    } else {
      setIva(0);
    }
    let totTemp =
      (e * subTotal) / 100 +
      subTotal +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  }

  function jalaComisionTDC(e) {
    setComisionTDC(parseFloat(e));
    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }
    let totTemp =
      (selectedImpuesto * subTotal) / 100 +
      subTotal +
      parseFloat(e) +
      parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  }

  function jalaComisionFlete(e) {
    setComisionFlete(parseFloat(e));
    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }
    let totTemp =
      (selectedImpuesto * subTotal) / 100 +
      subTotal +
      parseFloat(comisionTDC) +
      parseFloat(e);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  }

  function autorizaCambio() {
    if (password === import.meta.env.VITE_PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
      Swal.fire("Good job!", "Se autorizo con exito", "success");
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  // function jalaCondPago(e) {
  //   setCondPago(e);
  //   setEfectivo(0);
  //   setTDC(0);
  //   setTransfer(0);
  //   setSaldo(total_general);
  //   setFechaTransfer("NA");
  //   setDestino("NA");
  //   setTerminal("NA");
  // }

  function jalaEfectivo(e) {
    setEfectivo(e);
    setSaldo(total_general - e - tdc - transfer);
  }

  function jalaTransfer(e) {
    setTransfer(e);
    if (e > 0) {
      setDestino("");
    } else {
      setDestino("NA");
    }
    setSaldo(total_general - efectivo - tdc - e);
  }

  function jalaTDC(e) {
    setTDC(e);
    if (e > 0) {
      setTerminal("");
    } else {
      setTerminal("NA");
    }
    setSaldo(total_general - efectivo - e - transfer);
  }

  function solicitarAut() {
    setMailAutEnviado(true);

    axios.post(
      `${URL_WHATSAPP}SendMsg`,
      {
        number: import.meta.env.VITE_TELEFONO_SUPER_ADMIN,
        message: `Hola,
La tienda ${areaUserName} esta solicitando un cambio de precio.
Si lo autorizas proporciona la clave:
${randomCambiaPrecio}`,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    axios
      .post(
        URL_SEND_MAIL,
        {
          subject: "Cambio de Precio",
          email: import.meta.env.VITE_EMAIL_SUPER_ADMIN,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
       <th><img width="${
         import.meta.env.VITE_TAMANO_LOGO_MAIL
       }" align="center" src="${
            import.meta.env.VITE_LINK_SISTEMA
          }logoInstitucion.png" /></th>
       <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${
         import.meta.env.VITE_NOMBRE_INSTITUCION
       }</tr>
       <tbody>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>La tienda ${areaUserName} esta solicitando un cambio de precio, si lo autorizas proporciona la clave ${randomCambiaPrecio}</tr>
       </tbody>
       <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${
         import.meta.env.VITE_TELEFONO_INSTITUCION
       }</tr>
       <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${
         import.meta.env.VITE_LINK_SISTEMA
       }Logo-Sistemify-PDF.png" /> </a> </tr>
       </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )

      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || error.message || "Error desconocido"}`,
        });
        console.log(error);
      });
  }

  const options2 = useMemo(() => articulosUnicos.map((option) => {
    const junta = option.codigo;
    const firstLetter = option.codigo?.[0]?.toUpperCase() || "#";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  }), [articulosUnicos]);

  const handleChangeInputProporcion = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        const newValue = event.target.name === "precio"
          ? parseFloat(event.target.value)
          : event.target.value;
        return {
          ...i,
          [event.target.name]: newValue,
        };
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function BuscaArticuloProporcion(id, selectedArticulo) {
    inventarios.map((a) => {
      if (a.idArticulo === selectedArticulo.idArticulo) {
        let idArticulo = selectedArticulo.idArticulo;
        let articulosNombre =
          selectedArticulo.codigo + " " + selectedArticulo.nombre;
        let colores = a.colores;
        let tallas = a.tallas;

        setUrlPhoto(a.urlFoto);

        let precio;
        if (listaPrecios == 1) {
          precio = a.listaPrecioPieza;
        } else if (listaPrecios == 2) {
          precio = a.listaPrecioCorrida;
        } else if (listaPrecios == 3) {
          precio = a.listaPrecioPaquete;
        } else if (listaPrecios == 4) {
          precio = a.listaPrecioCaja;
        } else if (listaPrecios == 5) {
          precio = a.listaPrecioRebajas;
        }

        handleChangeInputArticuloProporcion(
          id,
          idArticulo,
          precio,
          articulosNombre,
          colores,
          tallas
        );
      }
    });
  }

  function BuscaCodigoProporcion(id, idArticuloParam) {
    if (idArticuloParam.length > 2) {
      inventarios.forEach((a) => {
        if (a.ean == idArticuloParam) {
          let articulosNombre = a.codigo + " " + a.nombre;
          let colores = a.colores;
          let tallas = a.tallas;
          let idArticuloFound = a.idArticulo;

          setUrlPhoto(a.urlFoto);

          let precio;
          if (listaPrecios == 1) {
            precio = a.listaPrecioPieza;
          } else if (listaPrecios == 2) {
            precio = a.listaPrecioCorrida;
          } else if (listaPrecios == 3) {
            precio = a.listaPrecioPaquete;
          } else if (listaPrecios == 4) {
            precio = a.listaPrecioCaja;
          } else if (listaPrecios == 5) {
            precio = a.listaPrecioRebajas;
          }

          handleChangeInputArticuloProporcion(
            id,
            idArticuloFound,
            precio,
            articulosNombre,
            colores,
            tallas
          );
        }
      });
    } else {
      const newInputArticulos = inputArticulos.map((i) => {
        if (id === i.id) {
          return {
            ...i,
            articulos: idArticuloParam,
            precio: 0,
            articulosNombre: "",
            cajas: 0,
            colores: [],
            tallas: [],
          };
        }
        return i;
      });
      setInputArticulos(newInputArticulos);
    }
  }

  const handleChangeInputArticuloProporcion = (
    id,
    idArticulo,
    precio,
    articulosNombre,
    colores,
    tallas
  ) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        return {
          ...i,
          articulos: idArticulo,
          precio: precio,
          articulosNombre: articulosNombre,
          cajas: 0,
          colores: colores,
          tallas: tallas,
        };
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function agregarProporcion(
    idArticulo,
    articulosNombre,
    precio,
    cajas,
    colores,
    tallas
  ) {
    if (cajas === 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La cantidad debe ser mayor a 0",
      });
      return;
    }
    if (inventarios.length === 0) {
      Swal.fire({
        icon: "error",
        title: inventariosError
          ? "No se pudo consultar el inventario"
          : "Sin existencia en esta tienda",
        text: inventariosError
          ? "No se pudo cargar el inventario de la tienda. Reintenta o recarga la pantalla."
          : `${selectedAreaName || user.areaName || "Esta tienda"} no tiene existencia de ningún artículo. Si la mercancía está en bodega, solicita un traspaso.`,
      });
      return;
    }
    axios
      .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        const newInputFields = allArticulos
          .map((i) => {
            // Validate arrays exist and have elements
            if (!i.articulos?.length || !i.colores?.length || !i.tallas?.length) {
              return null;
            }

            // Encuentra el inventario correspondiente
            const inventario = inventarios.find(
              (inv) =>
                String(inv.idArticulo) === String(i.articulos[0]._id) &&
                inv.color === i.colores[0].name &&
                inv.talla === i.tallas[0].name
            );

            if (!inventario) {
              return null;
            }

            // Calcula la cantidad solicitada y la final basada en disponibilidad
            const cantidadSolicitada = i.cantidad * cajas;
            const cantidadFinal = Math.min(inventario.cantidad, cantidadSolicitada);
            const excedeInventario = cantidadSolicitada > inventario.cantidad;

            return {
              id: uuidv4(),
              articulos: idArticulo,
              precio: precio,
              idInv: inventario._id,
              cantInv: inventario.cantidad,
              articulosNombre: articulosNombre,

              precioEsp: inventario.precioEsp,
              venta: inventario.venta,
              costoUnitario: inventario.costoUnitario,
              precioOriginal: inventario.venta,
              cantidad: cantidadFinal,
              cantidadSolicitada: cantidadSolicitada,
              excedeInventario: excedeInventario,
              total: cantidadFinal * precio,

              idTalla: i.tallas[0]._id,
              tallaNombre: i.tallas[0].name,
              idColor: i.colores[0]._id,
              colorNombre: i.colores[0].name,
              colores: colores,
              tallas: tallas,
              cajas: cantidadFinal / (inventario.piezasPorCaja || 1),
              idArticuloProporcion: inventario.idArticuloProporcion || i._id,
            };
          })
          .filter((i) => i !== null);

        // SYNCHRONOUS merge and validation BEFORE calling setInputFields
        const errorMessages = [];
        const currentFields = [...inputFields];
        const mergedFields = [...currentFields];

        for (const newItem of newInputFields) {
          const existingIndex = mergedFields.findIndex(
            (item) => item.idInv === newItem.idInv
          );

          if (existingIndex !== -1) {
            // Item already exists - update quantity with validation
            const existing = mergedFields[existingIndex];
            const newCantidad = existing.cantidad + newItem.cantidad;

            if (newCantidad > existing.cantInv) {
              errorMessages.push(
                `${existing.articulosNombre} - ${existing.colorNombre} - ${existing.tallaNombre}: Solo hay ${existing.cantInv} disponibles, ya tienes ${existing.cantidad} agregadas`
              );
              mergedFields[existingIndex] = {
                ...existing,
                cantidad: existing.cantInv,
                total: existing.cantInv * existing.precio,
              };
            } else {
              mergedFields[existingIndex] = {
                ...existing,
                cantidad: newCantidad,
                total: newCantidad * existing.precio,
              };
            }
          } else {
            // New item - check if original request exceeded available inventory
            if (newItem.excedeInventario) {
              errorMessages.push(
                `${newItem.articulosNombre} - ${newItem.colorNombre} - ${newItem.tallaNombre}: Solicitaste ${newItem.cantidadSolicitada}, solo hay ${newItem.cantInv} disponibles`
              );
            }
            mergedFields.push(newItem);
          }
        }

        // Show warning if inventory was exceeded
        if (errorMessages.length > 0) {
          Swal.fire({
            icon: "warning",
            title: "Inventario insuficiente",
            html: `<div style="text-align: left; max-height: 300px; overflow-y: auto;">
              <p>Algunos artículos exceden el inventario disponible:</p>
              <ul>${errorMessages.map(msg => `<li>${msg}</li>`).join('')}</ul>
              <p><strong>Se ajustaron las cantidades al máximo disponible.</strong></p>
            </div>`,
            width: 600,
          });
        }

        const updatedInputFields = mergedFields;

        const tallaOrder = [
          "EECH", "ECH", "CH", "M", "G", "EG", "2EG", "3EG", "4EG", "5EG", "6EG",
          "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15",
          "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30",
          "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45",
          "46", "47", "48", "49", "50", "5/6", "7/8", "10/12", "14/16",
        ];

        const sortedInputFields = updatedInputFields.sort((a, b) => {
          if (a.articulosNombre < b.articulosNombre) return -1;
          if (a.articulosNombre > b.articulosNombre) return 1;
          if (a.colorNombre < b.colorNombre) return -1;
          if (a.colorNombre > b.colorNombre) return 1;
          return tallaOrder.indexOf(a.tallaNombre) - tallaOrder.indexOf(b.tallaNombre);
        });

        // Calculate total quantities and amounts
        const totalCantidad = sortedInputFields.reduce(
          (acc, curr) => acc + parseFloat(curr.cantidad), 0
        );
        const TG = sortedInputFields.reduce(
          (acc, curr) => acc + parseFloat(curr.total), 0
        );

        // Update state with totals
        setTotalCantidad(totalCantidad);
        setSubTotal(TG);

        if (selectedImpuesto !== 0) {
          setIva((selectedImpuesto * TG) / 100);
        } else {
          setIva(0);
        }

        let totTemp =
          (selectedImpuesto * TG) / 100 + TG +
          parseFloat(comisionTDC) + parseFloat(comisionFlete);

        setTotalGeneral(totTemp);
        setSaldo(totTemp - efectivo - tdc - transfer);

        // Update state with sorted fields
        setInputFields(sortedInputFields);

        setInputArticulos([
          {
            id: uuidv4(),
            articulos: "",
            cajas: 0,
            precio: 0,
            articulosNombre: "",
            colores: [],
            tallas: [],
          },
        ]);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response?.data?.message || err.response?.data?.error || "Error al obtener los artículos de proporción",
        });
      });
  }

  const handleCreateNewArticuloTalla = async (
    idArticulo,
    idColor,
    tallaNombre,
    cantidad,
    precio,
    colores
  ) => {
    if (!cantidad || parseFloat(cantidad) <= 0) return;

    // Buscar la talla completa en el array de tallas
    const tallaCompleta = tallas.find((t) => t.name === tallaNombre);
    if (!tallaCompleta) return;

    // Buscar el color completo en el array de colores del artículo
    const colorCompleto = colores.find((c) => String(c._id) === String(idColor));
    if (!colorCompleto) return;

    // Find the inventory item for this specific combination
    const inventario = inventarios.find(
      (inv) =>
        String(inv.idArticulo) === String(idArticulo) &&
        inv.color === colorCompleto.name &&
        inv.talla === tallaNombre
    );

    if (!inventario) {
      return;
    }

    if (inventario.cantidad < parseFloat(cantidad)) {
      return;
    }

    // Check if this exact combination already exists
    const existingItem = inputFields.find(
      (item) => item.idArticuloProporcion === inventario.idArticuloProporcion
    );

    if (existingItem) {
      // Update existing item quantity
      const updatedFields = inputFields.map((field) => {
        if (field.idArticuloProporcion === inventario.idArticuloProporcion) {
          const newQuantity = field.cantidad + parseFloat(cantidad);
          return {
            ...field,
            cantidad: newQuantity,
            total: newQuantity * field.precio,
          };
        }
        return field;
      });
      setInputFields(updatedFields);
      ActualizaTotales();
      return;
    }

    // Buscar el artículo completo para obtener el código y nombre
    const articuloCompleto = articulosUnicos.find(
      (a) => String(a.idArticulo) === String(idArticulo)
    );
    if (!articuloCompleto) return;

    const newField = {
      id: uuidv4(),
      articulos: idArticulo,
      precio: precio,
      idInv: inventario._id,
      cantInv: inventario.cantidad,
      articulosNombre: `${articuloCompleto.codigo} ${articuloCompleto.nombre}`,
      precioEsp: inventario.precioEsp,
      venta: inventario.venta,
      costoUnitario: inventario.costoUnitario,
      precioOriginal: inventario.venta,
      cantidad: parseFloat(cantidad),
      total: parseFloat(cantidad) * precio,
      idTalla: tallaCompleta._id,
      tallaNombre: tallaNombre,
      idColor: idColor,
      colorNombre: colorCompleto.name,
      colores: colores,
      tallas: articuloCompleto.tallas || [],
      cajas: 0,
      idArticuloProporcion: inventario.idArticuloProporcion,
    };

    setInputFields((prevInputFields) => [...prevInputFields, newField]);
    ActualizaTotales();
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.ventasTiendas ? (
        <div className="card container col-12">
          <h3 align="center">Nueva Venta</h3>
          <Form onSubmit={saveVenta}>
            {selectedArea !== "" ? (
              <>
                <Input
                  type="checkbox"
                  onChange={(event) => {
                    setVistaCliente(event.currentTarget.checked);
                    setAlertasCliente("Si");
                  }}
                  checked={vistaCliente}
                />
                <h4 className="subMenuTitulo">
                  Deseas Dar de alta al Cliente?
                </h4>
              </>
            ) : (
              <>
                <Input type="checkbox" disabled />
                <h4 className="subMenuTitulo">
                  Deseas Dar de alta al Cliente?
                </h4>
              </>
            )}

            {vistaCliente ? (
              <>
                <Row>
                  <Col md={3}>
                    <Label>Nombre Comercial</Label>
                    <Input
                      type="text"
                      style={{ backgroundColor: "yellow" }}
                      placeholder="Nombre Comercial"
                      value={nombre_comercial}
                      required
                      onChange={(e) => {
                        setNombreComercial(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Razon Social</Label>
                    <Input
                      type="text"
                      placeholder="Razon Social"
                      value={razon_social}
                      required
                      onChange={(e) => {
                        setRazonSocial(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>RFC</Label>
                    <Input
                      type="text"
                      placeholder="RFC"
                      value={RFC}
                      required
                      onChange={(e) => {
                        setRFC(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Paqueteria</Label>
                    <Input
                      className="col-sm-12"
                      style={{ backgroundColor: "yellow" }}
                      type="select"
                      value={selectedPaqueteria}
                      required
                      onChange={(e) => {
                        setSelectedPaqueteria(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona </option>
                      {paqueterias
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Label>Calle</Label>
                    <Input
                      type="text"
                      placeholder="Calle"
                      value={calle}
                      required
                      onChange={(e) => {
                        setCalle(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>No. Ext</Label>
                    <Input
                      type="text"
                      placeholder="No. Ext"
                      value={numero_ext}
                      required
                      onChange={(e) => {
                        setNumeroExt(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>No. Int</Label>
                    <Input
                      type="text"
                      placeholder="No. Int"
                      value={numero_int}
                      required
                      onChange={(e) => {
                        setNumeroInt(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Pais</Label>
                    <Input
                      type="text"
                      placeholder="Pais"
                      value={pais}
                      required
                      onChange={(e) => {
                        setPais(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Label>Estado</Label>
                    <Input
                      type="text"
                      placeholder="Estado"
                      value={estado}
                      required
                      onChange={(e) => {
                        setEstado(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Ciudad</Label>
                    <Input
                      type="text"
                      placeholder="Ciudad"
                      value={ciudad}
                      required
                      onChange={(e) => {
                        setCiudad(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Delegacion</Label>
                    <Input
                      type="text"
                      placeholder="Delegacion o Municipio"
                      value={delegacion}
                      required
                      onChange={(e) => {
                        setDelegacion(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Colonia</Label>
                    <Input
                      type="text"
                      placeholder="Colonia"
                      value={colonia}
                      required
                      onChange={(e) => {
                        setColonia(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Label>CP</Label>
                    <Input
                      type="text"
                      placeholder="CP"
                      value={cp}
                      required
                      onChange={(e) => {
                        setCP(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Telefono</Label>
                    <Input
                      type="text"
                      style={{ backgroundColor: "yellow" }}
                      placeholder="Telefono"
                      value={telefono}
                      required
                      onChange={(e) => {
                        setTelefono(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Email</Label>
                    <Input
                      type="email"
                      placeholder="Email"
                      value={email}
                      required
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Vendedor</Label>
                    <Input
                      style={{ backgroundColor: "yellow" }}
                      className="col-sm-12"
                      type="select"
                      value={selectedVendedorInput}
                      required
                      onChange={(e) => {
                        setSelectedVendedorInput(e.target.value);
                        setSelectedVendedor(e.target.value.split(",")[0]);
                        setSelectedColaboradorName(
                          e.target.value.split(",")[1]
                        );
                      }}
                    >
                      <option value="0">Selecciona un Vendedor</option>
                      {colaboradores
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => {
                          return (
                            <option
                              value={[a._id, a.nombre + " " + a.apellido]}
                            >
                              {a.nombre} {a.apellido}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                </Row>

                <Row>
                  <Col md={3}>
                    <Label>Forma de Pago</Label>
                    <Input
                      type="select"
                      placeholder="Forma de Pago"
                      value={forma_pago}
                      required
                      onChange={(e) => {
                        setFormaPago(e.target.value);
                      }}
                    >
                      <option value="0">Forma de Pago</option>
                      <option value="Contado">Contado</option>
                      <option value="Credito">Credito</option>
                    </Input>
                  </Col>

                  <Col md={3}>
                    <Label>Plazo</Label>
                    <Input
                      type="select"
                      placeholder="Plazo"
                      value={plazo}
                      required
                      onChange={(e) => {
                        setPlazo(e.target.value);
                      }}
                    >
                      <option value="">Plazo</option>
                      <option value="0">0</option>
                      <option value="30">30</option>
                      <option value="60">60</option>
                      <option value="90">90</option>
                      <option value="120">120</option>
                      <option value="150">150</option>
                      <option value="180">180</option>
                    </Input>
                  </Col>

                  <Col md={3}>
                    <Label className="mr-sm-2">Grupo</Label>
                    <Input
                      className="col-sm-12"
                      style={{ backgroundColor: "yellow" }}
                      type="select"
                      value={selectedGrupo}
                      required
                      onChange={(e) => {
                        setSelectedGrupo(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona una Grupo</option>
                      {grupos
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Departamento</Label>
                    <Input
                      className="col-sm-12"
                      style={{ backgroundColor: "yellow" }}
                      type="select"
                      value={selectedDepartamento}
                      required
                      onChange={(e) => {
                        setSelectedDepartamento(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona </option>
                      {departamentos
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                </Row>

                <Row>
                  <Col md={3}>
                    <Label>Reg Fiscal</Label>
                    <Input
                      type="select"
                      placeholder="RegFiscal"
                      value={regFiscal}
                      required
                      onChange={(e) => {
                        setRegFiscal(e.target.value);
                      }}
                    >
                      <option value="">Reg Fiscal</option>
                      <option value="0">0</option>
                      <option value="601">
                        601 General de Ley Personas Morales
                      </option>
                      <option value="603">
                        603 Personas Morales con Fines no Lucrativos
                      </option>
                      <option value="605">
                        605 Sueldos y Salarios e Ingresos Asimilados al Salario
                      </option>
                      <option value="608">608 Demas Ingresos</option>
                      <option value="612">
                        612 Personas Fisicas con Actividad Empresarial
                      </option>
                      <option value="616">616 Sin Obligacion Fiscal</option>
                      <option value="621">621 Incorporacion Fiscal</option>
                      <option value="625">
                        625 Reg. de las act. emp. cpn ingresos a traves de plat.
                        tec.
                      </option>
                      <option value="626">
                        626 Regimen simplificado de Confianza
                      </option>
                    </Input>
                  </Col>

                  <Col md={3}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Uso de CDFI
                    </Label>
                    <Input
                      type="select"
                      placeholder="Uso de CDFI"
                      value={usoCFDI}
                      required
                      onChange={(e) => {
                        setUsoCFDI(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="G01">G01 Adquisición de mercancías</option>
                      <option value="G03">G03 Gastos en general</option>
                      <option value="S01">S01 Sin efectos fiscales</option>
                    </Input>
                  </Col>

                  <Col md={3}>
                    <Label>Forma Pago Fiscal</Label>
                    <Input
                      style={{ backgroundColor: "yellow" }}
                      type="select"
                      value={formaPagoSAT}
                      required
                      onChange={(e) => {
                        setFormaPagoSAT(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="01"> 01 Efectivo</option>
                      <option value="02"> 02 Cheque nominativo</option>
                      <option value="03">
                        {" "}
                        03 Transferencia electrónica de fondos
                      </option>
                      <option value="04"> 04 Tarjeta de crédito</option>
                      <option value="05"> 05 Monedero electrónico</option>
                      <option value="06"> 06 Dinero electrónico</option>
                      <option value="08"> 08 Vales de despensa</option>
                      <option value="12"> 12 Dación en pago</option>
                      <option value="13"> 13 Pago por subrogación</option>
                      <option value="14"> 14 Pago por consignación</option>
                      <option value="15"> 15 Condonación</option>
                      <option value="17"> 17 Compensación</option>
                      <option value="23"> 23 Novación</option>
                      <option value="24"> 24 Confusión</option>
                      <option value="25"> 25 Remisión de deuda</option>
                      <option value="26"> 26 Prescripción o caducidad</option>
                      <option value="27">
                        {" "}
                        27 A satisfacción del acreedor
                      </option>
                      <option value="28"> 28 Tarjeta de débito</option>
                      <option value="29"> 29 Tarjeta de servicios</option>
                      <option value="30"> 30 Aplicación de anticipos</option>
                      <option value="99"> 99 Por definir</option>
                    </Input>
                  </Col>

                  <Col md={3}>
                    <Label>Metodo Pago Fiscal</Label>
                    <Input
                      type="select"
                      value={metodoPagoSAT}
                      required
                      onChange={(e) => {
                        setMetodoPagoSAT(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="PUE">
                        PUE (Pago de Una Sola Exhibición)
                      </option>
                      <option value="PPD">
                        PPD (Pago en Parcialidades o Diferido)
                      </option>
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label>Condiciones de Pago Fiscal</Label>
                    <Input
                      type="text"
                      value={condicionesPagoSAT}
                      required
                      onChange={(e) => {
                        setCondicionesPagoSAT(e.target.value);
                      }}
                    />
                  </Col>

                  <Col md={3}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Observaciones
                    </Label>
                    <Input
                      type="text"
                      placeholder="Observaciones"
                      value={observacionesCliente}
                      required
                      onChange={(e) => {
                        setObservacionesCliente(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <br />
              </>
            ) : undefined}
            <div style={{ position: "relative" }}>
              <Row>
                <>
                  {!vistaCliente ? (
                    <>
                      {selectedArea !== "" ? (
                        <>
                          <Col md={3}>
                            <Label className="mr-sm-2">Cliente</Label>
                            <Autocomplete
                              size="small"
                              value={value}
                              onChange={(event, selectedCliente) => {
                                if (selectedCliente && selectedCliente.vendedor && selectedCliente.vendedor.length > 0) {
                                  setValue(selectedCliente);
                                  setAlertasCliente(selectedCliente.alertas || "No");
                                  setSelectedColaborador(
                                    selectedCliente.vendedor[0]._id
                                  );
                                  setSelectedColaboradorName(
                                    selectedCliente.vendedor[0].nombre +
                                      " " +
                                      selectedCliente.vendedor[0].apellido
                                  );
                                  setListaPrecios(selectedCliente.listaPrecios || 1);
                                }
                              }}
                              options={options.sort(
                                (a, b) =>
                                  -b.firstLetter.localeCompare(a.firstLetter)
                              )}
                              groupBy={(option) => option.firstLetter}
                              getOptionLabel={(option) => option?.junta || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Selecciona"
                                  variant="outlined"
                                />
                              )}
                              renderOption={(props, option) => (
                                <li {...props} key={option._id}>
                                  {option.codigo} {option.nombre_comercial}
                                </li>
                              )}
                            />
                          </Col>
                          <Col md={2}>
                            <Label className="mr-sm-2">Vendedor</Label>
                            <Input
                              style={{ backgroundColor: "yellow" }}
                              className="col-sm-12"
                              type="select"
                              value={selectedVendedorInput}
                              required
                              onChange={(e) => {
                                setSelectedVendedorInput(e.target.value);
                                setSelectedVendedor(
                                  e.target.value.split(",")[0]
                                );
                                setSelectedColaboradorName(
                                  e.target.value.split(",")[1]
                                );
                              }}
                            >
                              <option value="0">Selecciona un Vendedor</option>
                              {colaboradores
                                .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                                .map((a) => {
                                  return (
                                    <option
                                      value={[
                                        a._id,
                                        a.nombre + " " + a.apellido,
                                      ]}
                                    >
                                      {a.nombre} {a.apellido}
                                    </option>
                                  );
                                })}
                            </Input>
                          </Col>

                          <Col md={1}>
                            <Label>Paqueteria</Label>
                            <Input
                              className="col-sm-12"
                              type="select"
                              value={idPaqueteria}
                              required
                              onChange={(e) => {
                                setIdPaqueteria(e.target.value);
                              }}
                            >
                              <option value="0">Selecciona </option>
                              {paqueterias
                                .sort((a, b) => (a.name > b.name ? 1 : -1))
                                .map((a) => {
                                  return (
                                    <option value={a._id}>{a.name}</option>
                                  );
                                })}
                            </Input>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col md={3}>
                            <Label className="mr-sm-2">Cliente</Label>
                            <Autocomplete
                              size="small"
                              value={value}
                              onChange={(event, selectedCliente) => {
                                if (selectedCliente && selectedCliente.vendedor && selectedCliente.vendedor.length > 0) {
                                  setValue(selectedCliente);
                                  setAlertasCliente(selectedCliente.alertas || "No");
                                  setSelectedColaborador(
                                    selectedCliente.vendedor[0]._id
                                  );
                                  setSelectedColaboradorName(
                                    selectedCliente.vendedor[0].nombre +
                                      " " +
                                      selectedCliente.vendedor[0].apellido
                                  );
                                }
                              }}
                              disabled
                              options={options.sort(
                                (a, b) =>
                                  -b.firstLetter.localeCompare(a.firstLetter)
                              )}
                              groupBy={(option) => option.firstLetter}
                              getOptionLabel={(option) => option?.junta || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Selecciona"
                                  variant="outlined"
                                />
                              )}
                              renderOption={(props, option) => (
                                <li {...props} key={option._id}>
                                  {option.codigo} {option.nombre_comercial}
                                </li>
                              )}
                            />
                          </Col>
                          <Col md={2}>
                            <Label className="mr-sm-2">Vendedor</Label>
                            <Input
                              style={{ backgroundColor: "yellow" }}
                              className="col-sm-12"
                              type="select"
                              value={selectedVendedorInput}
                              required
                              onChange={(e) => {
                                setSelectedVendedorInput(e.target.value);
                                setSelectedVendedor(
                                  e.target.value.split(",")[0]
                                );
                                setSelectedColaboradorName(
                                  e.target.value.split(",")[1]
                                );
                              }}
                            >
                              <option value="0">Selecciona un Vendedor</option>
                              {colaboradores
                                .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                                .map((a) => {
                                  return (
                                    <option
                                      value={[
                                        a._id,
                                        a.nombre + " " + a.apellido,
                                      ]}
                                    >
                                      {a.nombre} {a.apellido}
                                    </option>
                                  );
                                })}
                            </Input>
                          </Col>

                          <Col md={1}>
                            <Label>Paqueteria</Label>
                            <Input
                              className="col-sm-12"
                              type="select"
                              value={idPaqueteria}
                              required
                              disabled
                            >
                              <option value="0">Selecciona </option>
                              {paqueterias
                                .sort((a, b) => (a.name > b.name ? 1 : -1))
                                .map((a) => {
                                  return (
                                    <option value={a._id}>{a.name}</option>
                                  );
                                })}
                            </Input>
                          </Col>
                        </>
                      )}
                    </>
                  ) : undefined}
                  {vistaCliente ? (
                    <>
                      <Col md={12}>
                        <h4>Venta</h4>
                      </Col>
                      <br />
                    </>
                  ) : undefined}

                  {/* <Col md={1}>
                    <Label>Cond de Pago</Label>
                    <Input
                      type="select"
                      value={condPago}
                      required
                      onChange={(e) => {
                        jalaCondPago(e.target.value);
                      }}
                    >
                      <option value={"Contado"}>Contado</option>
                      <option value={"Credito"}>Credito</option>
                    </Input>
                  </Col> */}
                  <Col md={1}>
                    <Label>Comision TDC</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Comision TDC"
                      value={comisionTDC}
                      required
                      onChange={(e) => {
                        jalaComisionTDC(e.target.value);
                      }}
                    />
                  </Col>

                  <Col md={1}>
                    <Label>Flete</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Flete"
                      value={comisionFlete}
                      required
                      onChange={(e) => {
                        jalaComisionFlete(e.target.value);
                      }}
                    />
                  </Col>

                  <Col md={1}>
                    <Label>Impuestos %</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={selectedImpuesto}
                      onChange={(e) => {
                        calculaImpuesto(e.target.value);
                      }}
                    />
                  </Col>
                </>
              </Row>
              {urlPhoto && (
                <div
                  style={{
                    position: "absolute",
                    right: "5%", // Use percentage instead of fixed pixels
                    top: "-40px", // Keep this fixed to maintain vertical alignment
                    width: "150px", // You could also use % or vw units here for responsive width
                    height: "auto",
                    maxHeight: "80px",
                    zIndex: 2,
                  }}
                >
                  <img
                    src={urlPhoto}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      background: "#fff",
                    }}
                  />
                </div>
              )}
            </div>
            <Row>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>

              <Col md={2}>
                <Label>Cambio de Precio</Label>
                <br />
                <Button
                  size="sm"
                  className="btn"
                  color="info"
                  onClick={(e) => toggleCambiaPrecio()}
                >
                  Solicitar
                </Button>
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Selecciona</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cajas</Label>
              </Col>
            </Row>
            <h4 className="text-dark">
              <b>Agregar Caja</b>
            </h4>
            <>
              {/* QR Scanner Input */}
              <Row className=""></Row>

              {/* Proportion Input Section */}
              <Row className="">
                <Col md={2}>
                  <Label className="mr-sm-2">Escanea el QR</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Selecciona</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cajas</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Precio</Label>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={2}>
                  <Input
                    name="articulos"
                    type="string"
                    value={inputArticulos[0]?.articulos}
                    onKeyDown={preventEnterSubmit}
                    onChange={(event) => {
                      BuscaCodigoProporcion(
                        inputArticulos[0].id,
                        event.target.value
                      );
                    }}
                  ></Input>
                </Col>
                <Col md={2}>
                  <Autocomplete
                    size="small"
                    value={inputArticulos[0]?.articulosNombre || ""}
                    onChange={(event, selectedArticulo) => {
                      BuscaArticuloProporcion(
                        inputArticulos[0]?.id || "template",
                        selectedArticulo
                      );
                    }}
                    options={options2.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option?.junta || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        {option.codigo} {option.nombre}
                      </li>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Input
                    name="articulosNombre"
                    type="string"
                    placeholder="Articulo"
                    value={inputArticulos[0].articulosNombre || ""}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="cajas"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cajas"
                    value={inputArticulos[0].cajas || ""}
                    onKeyDown={preventEnterSubmit}
                    onChange={(event) =>
                      handleChangeInputProporcion(
                        inputArticulos[0]?.id || "template",
                        event
                      )
                    }
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={inputArticulos[0]?.precio || ""}
                    onChange={(event) =>
                      handleChangeInputProporcion(
                        inputArticulos[0]?.id || "template",
                        event
                      )
                    }
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="success"
                    disabled={
                      !inputArticulos[0]?.articulos || !inputArticulos[0]?.cajas
                    }
                    onClick={() =>
                      agregarProporcion(
                        inputArticulos[0]?.articulos,
                        inputArticulos[0]?.articulosNombre,
                        inputArticulos[0]?.precio,
                        inputArticulos[0]?.cajas,
                        inputArticulos[0]?.colores,
                        inputArticulos[0]?.tallas
                      )
                    }
                    tabindex="-1"
                  >
                    Agregar
                  </Button>
                </Col>
              </Row>

              {/* MANUAL PRODUCT SECTION */}
              <h4 className="text-dark">
                <b>Agregar Pieza</b>
              </h4>
              <Row className="">
                <Col md={2}>
                  <Label className="mr-sm-2">Escanea el QR</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Selecciona</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Color</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Talla</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Precio</Label>
                </Col>
              </Row>

              <Row>
                <Col md={2}>
                  <Input
                    name="scannerInput"
                    type="text"
                    placeholder="Escanear código"
                    innerRef={scannerInputRef}
                    onKeyDown={handleScannerKeyDown}
                    autoComplete="off"
                  ></Input>
                </Col>
                <Col md={2}>
                  <Autocomplete
                    size="small"
                    value={manualInput?.articulosNombre || ""}
                    onChange={(event, selectedArticulo) => {
                      handleManualArticuloChange(selectedArticulo);
                    }}
                    options={options2.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option?.junta || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        {option.codigo} {option.nombre}
                      </li>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Input
                    type="text"
                    value={manualInput?.articulosNombre || ""}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="idColor"
                    type="select"
                    value={manualInput?.idColor || ""}
                    onChange={handleManualInputChange}
                  >
                    <option value="">Selecciona Color</option>
                    {manualInput?.colores?.map((color) => (
                      <option key={color._id} value={color._id}>
                        {color.name}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={1}>
                  <Input
                    name="idTalla"
                    type="select"
                    value={manualInput.idTalla || ""}
                    onChange={handleManualInputChange}
                  >
                    <option value="">Selecciona Talla</option>
                    {manualInput.tallas &&
                      manualInput.tallas.map((talla) => (
                        <option key={talla._id} value={talla._id}>
                          {talla.name}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={1}>
                  <Input
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    disabled={!manualInput?.idColor || !manualInput?.idTalla}
                    value={manualInput?.cantidad || 0}
                    onKeyDown={preventEnterSubmit}
                    onChange={handleManualInputChange}
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="precio"
                    type="number"
                    value={manualInput?.precio || 0}
                    onKeyDown={preventEnterSubmit}
                    onChange={handleManualInputChange}
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="success"
                    onClick={handleManualAdd}
                    disabled={
                      !manualInput?.articulosNombre ||
                      !manualInput?.idColor ||
                      !manualInput?.idTalla ||
                      !manualInput?.cantidad
                    }
                    tabindex="-1"
                  >
                    Agregar
                  </Button>
                </Col>
              </Row>
            </>

            <br />
            <hr />

            <div>
              {Object.entries(
                inputFields
                  .filter((field) => field.articulosNombre && field.articulos)
                  .reduce((acc, field) => {
                    const key = `${field.articulosNombre}`;
                    if (!acc[key]) {
                      acc[key] = {
                        articuloInfo: {
                          articulosNombre: field.articulosNombre,
                          articulos: field.articulos,
                          availableTallas: Array.from(
                            new Set(
                              inputFields
                                .filter(
                                  (f) =>
                                    f.articulosNombre === field.articulosNombre
                                )
                                .map((f) => f.tallaNombre)
                                .filter(Boolean)
                                .sort((a, b) => {
                                  return (
                                    customSizeOrder.indexOf(a) -
                                    customSizeOrder.indexOf(b)
                                  );
                                })
                            )
                          ),
                        },
                        colorGroups: [],
                      };
                    }

                    const existingColorIndex = acc[key].colorGroups.findIndex(
                      (item) => item.idColor === field.idColor
                    );

                    if (existingColorIndex === -1) {
                      acc[key].colorGroups.push({
                        id: field.id,
                        articulos: field.articulos,
                        articulosNombre: field.articulosNombre,
                        idColor: field.idColor,
                        colorNombre: field.colorNombre,
                        colores: field.colores,
                        precioOriginal: field.precioOriginal,
                        precio: field.precio,
                        quantities: {
                          [field.tallaNombre]: {
                            cantidad: field.cantidad,
                            id: field.id,
                            cantInv: field.cantInv,
                          },
                        },
                        total: field.cantidad * field.precio,
                      });
                    } else {
                      // If the size already exists for this color, sum the quantities
                      if (
                        acc[key].colorGroups[existingColorIndex].quantities[
                          field.tallaNombre
                        ]
                      ) {
                        acc[key].colorGroups[existingColorIndex].quantities[
                          field.tallaNombre
                        ].cantidad += field.cantidad;
                      } else {
                        acc[key].colorGroups[existingColorIndex].quantities[
                          field.tallaNombre
                        ] = {
                          cantidad: field.cantidad,
                          id: field.id,
                          cantInv: field.cantInv,
                        };
                      }
                      acc[key].colorGroups[existingColorIndex].total +=
                        field.cantidad * field.precio;
                    }
                    return acc;
                  }, {})
              ).map(([articuloNombre, { articuloInfo, colorGroups }]) => {
                // Calculate totals for this article
                const articleTotals = colorGroups.reduce(
                  (totals, group) => {
                    const quantitySum = Object.values(group.quantities).reduce(
                      (sum, q) => sum + (parseFloat(q.cantidad) || 0),
                      0
                    );
                    const priceSum = Object.values(group.quantities).reduce(
                      (sum, q) =>
                        sum + (parseFloat(q.cantidad) || 0) * group.precio,
                      0
                    );

                    return {
                      items: totals.items + quantitySum,
                      price: totals.price + priceSum,
                      singlePrice: group.precio,
                    };
                  },
                  { items: 0, price: 0 }
                );

                return (
                  <div key={articuloNombre} className="mb-8">
                    <div className="d-flex align-items-center border-t-2 border-gray-200 pt-2 pb-2 bg-gray-50">
                      <div className="d-flex align-items-center">
                        <Button
                          size="sm"
                          className="btn mr-3"
                          color="info"
                          onClick={() =>
                            setExpandedTables((prev) => ({
                              ...prev,
                              [articuloNombre]: !prev[articuloNombre],
                            }))
                          }
                        >
                          <i
                            className={`fas fa-chevron-${
                              expandedTables[articuloNombre] ? "up" : "down"
                            }`}
                          ></i>
                        </Button>
                        <h4 className="negrita mb-0 mr-4">{articuloNombre}</h4>
                      </div>
                      {!expandedTables[articuloNombre] && (
                        <div className="d-flex align-items-center">
                          <span
                            className="mr-4 text-dark"
                            style={{ fontSize: "18px" }}
                          >
                            <strong style={{ fontSize: "18px" }}>
                              Piezas:
                            </strong>{" "}
                            {articleTotals.items}
                          </span>
                          <span
                            className="mr-4 text-dark"
                            style={{ fontSize: "18px" }}
                          >
                            <strong style={{ fontSize: "18px" }}>
                              Precio:
                            </strong>{" "}
                            $
                            {articleTotals.singlePrice.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                          <span
                            className="text-dark"
                            style={{ fontSize: "18px" }}
                          >
                            <strong style={{ fontSize: "18px" }}>Total:</strong>{" "}
                            $
                            {articleTotals.price.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                      )}
                    </div>

                    {expandedTables[articuloNombre] && (
                      <Table borderless>
                        <thead>
                          <tr>
                            <th>Articulo</th>
                            <th>Color</th>
                            {articuloInfo.availableTallas.map((talla) => (
                              <th key={talla} style={{ maxWidth: "35px" }}>
                                {talla}
                              </th>
                            ))}
                            <th style={{ maxWidth: "60px" }}>Disponible</th>
                            <th style={{ maxWidth: "60px" }}>
                              Precio Original
                            </th>
                            <th style={{ maxWidth: "60px" }}>Precio</th>
                            <th style={{ maxWidth: "60px" }}>Total</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {colorGroups.map((group) => (
                            <tr key={`${group.id}-${group.idColor}`}>
                              {/* Your existing row content */}
                              <td style={{ maxWidth: "60px" }}>
                                <Input
                                  name="articulo"
                                  type="string"
                                  placeholder="Articulo"
                                  value={group.articulosNombre}
                                  disabled
                                />
                              </td>
                              <td style={{ maxWidth: "35px" }}>
                                <Input
                                  name="idColor"
                                  type="select"
                                  value={group.idColor}
                                  disabled
                                >
                                  <option value="">Selecciona</option>
                                  {group.colores?.map((a) => (
                                    <option key={a._id} value={a._id}>
                                      {a.name}
                                    </option>
                                  ))}
                                </Input>
                              </td>
                              {articuloInfo.availableTallas.map((talla) => (
                                <td key={talla} style={{ maxWidth: "40px" }}>
                                  <Input
                                    name="cantidad"
                                    type="number"
                                    min="0"
                                    step="any"
                                    value={
                                      group.quantities[talla]?.cantidad || 0
                                    }
                                    onChange={(event) => {
                                      if (group.quantities[talla]?.id) {
                                        // Si existe el registro, usar la función existente
                                        handleChangeInputCantidad(
                                          group.quantities[talla].id,
                                          event
                                        );
                                      } else {
                                        // Si no existe el registro, crear uno nuevo
                                        handleCreateNewArticuloTalla(
                                          group.articulos,
                                          group.idColor,
                                          talla,
                                          event.target.value,
                                          group.precio,
                                          group.colores
                                        );
                                      }
                                    }}
                                  />
                                </td>
                              ))}
                              <td style={{ maxWidth: "80px" }}>
                                <Input
                                  name="pendiente_surtir"
                                  type="text"
                                  value={
                                    Object.entries(group.quantities)
                                      .map(
                                        ([talla, data]) =>
                                          `${talla}:${data.cantInv}`
                                      )
                                      .join("|") || "0"
                                  }
                                  disabled
                                />
                              </td>
                              <td style={{ maxWidth: "60px" }}>
                                <Input
                                  name="precioOriginal"
                                  type="number"
                                  min="0"
                                  step="any"
                                  placeholder="PrecioOriginal"
                                  value={group.precioOriginal}
                                  disabled
                                />
                              </td>
                              <td style={{ maxWidth: "60px" }}>
                                <Input
                                  style={
                                    group.precioOriginal - 50 > group.precio
                                      ? { backgroundColor: "#ed8c8c" }
                                      : null
                                  }
                                  name="precio"
                                  type="number"
                                  min="0"
                                  step="any"
                                  placeholder="Precio"
                                  value={group.precio}
                                  required
                                  onChange={(event) =>
                                    handleChangeInput(group.id, event)
                                  }
                                />
                              </td>
                              <td style={{ maxWidth: "80px" }}>
                                <Input
                                  name="total"
                                  type="number"
                                  min="0"
                                  step="any"
                                  placeholder="total"
                                  value={group.total}
                                  disabled
                                />
                              </td>
                              <td>
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  onClick={() => handleRemoveFields(group.id)}
                                  tabindex="-1"
                                >
                                  <i className="fas fa-minus"></i>
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </div>
                );
              })}
            </div>

            <br />
            <Row>
              <Col md={6}></Col>
              <Col md={1}>
                <h4 align="right">Total Piezas:</h4>
              </Col>
              <Col md={1}>
                <h4 align="right">
                  {new Intl.NumberFormat("en-US").format(total_cantidad)}
                </h4>
              </Col>
              <Col md={1}></Col>
              <Col md={1}>
                <h4 align="right">Subtotal:</h4>
              </Col>
              <Col md={1}>
                <h4 align="right">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(subTotal)}
                </h4>
              </Col>
            </Row>

            <Row>
              <Col md={9}></Col>
              <Col md={1}>
                <h4 align="right">IVA:</h4>
              </Col>
              <Col md={1}>
                <h4 align="right">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(iva)}
                </h4>
              </Col>
            </Row>

            <Row>
              <Col md={9}></Col>
              <Col md={1}>
                <h4 align="right">Total:</h4>
              </Col>
              <Col md={1}>
                <h4 align="right">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(total_general)}
                </h4>
              </Col>
            </Row>

            <Row>
              <Col md={3}></Col>
              {condPago === "Contado" ? (
                <Col md={1}>
                  <Label>Efectivo</Label>
                  <Input
                    type="number"
                    min="0"
                    step="any"
                    value={efectivo}
                    required
                    onChange={(e) => {
                      jalaEfectivo(e.target.value);
                    }}
                  />
                </Col>
              ) : (
                <Col md={1}>
                  <Label>Efectivo</Label>
                  <Input
                    type="number"
                    min="0"
                    step="any"
                    value={efectivo}
                    required
                    disabled
                  />
                </Col>
              )}

              {condPago === "Contado" ? (
                <>
                  <Col md={1}>
                    <Label>TDC</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={tdc}
                      required
                      onChange={(e) => {
                        jalaTDC(e.target.value);
                      }}
                    />
                  </Col>

                  {tdc > 0 ? (
                    <Col md={1}>
                      <Label>Terminal</Label>
                      <Input
                        type="select"
                        value={terminal}
                        required
                        onChange={(e) => {
                          setTerminal(e.target.value);
                        }}
                      >
                        <option value="NA">Selecciona</option>
                        <option value="BBVA">BBVA</option>
                      </Input>
                    </Col>
                  ) : (
                    <Col md={1}>
                      <Label>Terminal</Label>
                      <Input type="text" value={terminal} disabled />
                    </Col>
                  )}
                </>
              ) : (
                <>
                  <Col md={1}>
                    <Label>TDC</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={tdc}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Label>Terminal</Label>
                    <Input type="text" value={terminal} disabled />
                  </Col>
                </>
              )}

              {condPago === "Contado" ? (
                <>
                  <Col md={1}>
                    <Label>Transfer</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={transfer}
                      required
                      onChange={(e) => {
                        jalaTransfer(e.target.value);
                      }}
                    />
                  </Col>
                  {transfer > 0 ? (
                    <>
                      <Col md={1}>
                        <Label>Destino</Label>
                        <Input
                          type="select"
                          value={destino}
                          required
                          onChange={(e) => {
                            setDestino(e.target.value);
                          }}
                        >
                          <option value="NA">Selecciona</option>
                          <option value="BBVA">BBVA</option>
                        </Input>
                      </Col>
                      <Col md={1}>
                        <Label>Fecha Transfer</Label>
                        <Input
                          type="date"
                          value={fechaTransfer}
                          required
                          onChange={(e) => {
                            setFechaTransfer(e.target.value);
                          }}
                        />
                      </Col>
                    </>
                  ) : (
                    <>
                      <Col md={1}>
                        <Label>Destino</Label>
                        <Input type="text" value={destino} disabled />
                      </Col>
                      <Col md={1}>
                        <Label>Fecha Transfer</Label>
                        <Input
                          type="date"
                          value={fechaTransfer}
                          required
                          disabled
                        />
                      </Col>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Col md={1}>
                    <Label>Transfer</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={transfer}
                      required
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Label>Destino</Label>
                    <Input type="text" value={destino} disabled />
                  </Col>
                </>
              )}

              <Col md={1}>
                <Label>Saldo</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={saldo}
                  required
                  disabled
                />
              </Col>
            </Row>

            <br />
            {validaBoton && inputFields.some((c) => c.cantidad > 0) ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/MenuTiendas"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Precio</h4>
            </ModalHeader>
            <ModalBody>
              {mailAutEnviado === false ? (
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={(e) => solicitarAut()}
                  >
                    Solicitar Autorizacion
                  </Button>
                </Col>
              ) : (
                <>
                  <Input
                    bsSize="sm"
                    type="password"
                    placeholder="Password"
                    value={password}
                    required
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <br />
                  <Row>
                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => autorizaCambio()}
                      >
                        Autorizar
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => solicitarAut()}
                      >
                        Reenviar Solicitud
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default VentasTiendasCreate;
